//Player history
//This will go through all the leagues/teams that a player used to play for
//and show all their stats.
import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Players.css'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ad from '../../images/Berardinelli.JPG'
import YouTube from 'react-youtube'
import Footer from '../../shared/components/UIElements/Footer'

var getYouTubeID = require('get-youtube-id')

const PlayerHistory = () => {
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedRosters, setLoadedRosters] = useState()
	const [listOfVideos, setListOfVideos] = useState()
	const [ids, setIds] = useState([])
	const [firstName, setFirstName] = useState()
	const [lastName, setLastName] = useState()
	const [middleInitial, setMiddleInitial] = useState()
	const [photo, setPhoto] = useState()
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const playerId = useParams().playerId

	//
	//Make a call to getPlayerHistoryByPlayerId in player-controller
	//
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/player/${playerId}/history`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedRosters(responseData.listOfRosters)
				setListOfVideos(responseData.listOfVideos)
				setFirstName(responseData.firstName)
				setLastName(responseData.lastName)
				setPhoto(responseData.photo)
				setMiddleInitial(responseData.middleInitial)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [playerId])
	//
	//
	useEffect(() => {
		if (!listOfVideos || listOfVideos.length === 0) {
			setIds([])
			setVideoTitles([])
			setVideoCaptions([])
			return
		}

		const newTitles = listOfVideos.map((video) => video.videoTitle)
		const newIds = listOfVideos.map((video) => getYouTubeID(video.videoURL))
		const newCaptions = listOfVideos.map((video) => video.videoCaption)

		setVideoTitles(newTitles)
		setIds(newIds)
		setVideoCaptions(newCaptions)
	}, [listOfVideos])
	//
	//
	const errorHandler = () => {
		setError(null)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<StatsAndStandingsHome />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && loadedRosters && (
					<div className='Roster playerHistorySection'>
						{/* Existing desktop/tablet layout */}
						<div className='playerHistoryDesktop'>
							{photo && (
								<div className='photoDiv'>
									<img
										src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
										alt={`${firstName} ${lastName}`}
										className='playerPhoto'
									/>
								</div>
							)}

							<h1>
								{firstName} {middleInitial} {lastName}
							</h1>

							<h3 className='h3Center'>Player History</h3>

							<table id='bottomRoster'>
								<thead>
									<tr>
										<th>League</th>
										<th>Session</th>
										<th>Team</th>
										<th>#</th>
										<th>G</th>
										<th>A</th>
										<th>Total</th>
									</tr>
								</thead>

								<tbody>
									{loadedRosters.map((team, key) => {
										return (
											<tr key={team._id || key}>
												<td>{team.leagueName}</td>

												<td>
													{team.session} {team.year}
												</td>

												<td>
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/league/${team.leagueId}/${team.session}/${team.year}/${team.teamName}`}
													>
														{team.teamName}
													</Link>
												</td>

												<td>{team.number}</td>
												<td>{team.goals}</td>
												<td>{team.assists}</td>
												<td>{team.goals + team.assists}</td>
											</tr>
										)
									})}
								</tbody>
							</table>

							<div style={{ marginTop: '3rem' }} className='imgDiv'>
								<a
									href='https://www.facebook.com/berardinellischoolofdriving'
									target='_blank'
									rel='noreferrer'
								>
									<img src={ad} alt='Berardinelli School of Driving' />
								</a>
							</div>
						</div>

						{/* New mobile-only layout */}
						<div className='playerHistoryMobile'>
							<div
								className={`playerHistoryMobile__playerCard ${
									photo
										? 'playerHistoryMobile__playerCard--withPhoto'
										: 'playerHistoryMobile__playerCard--noPhoto'
								}`}
							>
								{photo && (
									<img
										src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
										alt={`${firstName} ${lastName}`}
										className='playerHistoryMobile__photo'
									/>
								)}

								<div className='playerHistoryMobile__name'>
									{firstName} {middleInitial} {lastName}
								</div>

								<div className='playerHistoryMobile__divider'></div>

								<div className='playerHistoryMobile__title'>Player History</div>
							</div>

							<div className='playerHistoryMobile__tableCard'>
								<table className='playerHistoryMobile__table'>
									<thead>
										<tr>
											<th>League</th>
											<th>Session</th>
											<th>Team</th>
											<th>#</th>
											<th>G</th>
											<th>A</th>
											<th>Total</th>
										</tr>
									</thead>

									<tbody>
										{loadedRosters.map((team, key) => {
											return (
												<tr key={`mobile-history-${team._id || key}`}>
													<td>{team.leagueName}</td>

													<td>
														<span className='playerHistoryMobile__session'>
															{team.session}
														</span>

														<span className='playerHistoryMobile__year'>
															{team.year}
														</span>
													</td>

													<td className='playerHistoryMobile__team'>
														<Link
															to={`/league/${team.leagueId}/${team.session}/${team.year}/${team.teamName}`}
															className='playerHistoryMobile__teamLink'
														>
															{team.teamName}
														</Link>
													</td>

													<td>{team.number}</td>
													<td>{team.goals}</td>
													<td>{team.assists}</td>

													<td className='playerHistoryMobile__total'>
														{team.goals + team.assists}
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>

							<div className='playerHistoryMobile__ad'>
								<a
									href='https://www.facebook.com/berardinellischoolofdriving'
									target='_blank'
									rel='noreferrer'
								>
									<img src={ad} alt='Berardinelli School of Driving' />
								</a>
							</div>
						</div>
					</div>
				)}
				{!isLoading && listOfVideos && listOfVideos.length > 0 && (
					<div className='section pt-5 playerVideos'>
						<div style={{ overflowX: 'hidden' }}>
							{/* Existing desktop/tablet heading */}
							<div className='playerVideosDesktopHeading'>
								<div className='row'>
									<div className='col text-center mb-0'>
										<h1 className='text-sh-dark display-2'>Check it out!</h1>
									</div>
								</div>
							</div>

							{/* Mobile-only heading */}
							<div className='playerHistoryVideoHeading'>
								<div className='playerHistoryVideoHeading__top'>
									<span className='playerHistoryVideoHeading__line'></span>

									<span className='playerHistoryVideoHeading__icon'>
										<span className='playerHistoryVideoHeading__screen'>
											<span className='playerHistoryVideoHeading__play'></span>
										</span>
									</span>

									<span className='playerHistoryVideoHeading__line'></span>
								</div>

								<h1>Check it out!</h1>
							</div>

							<div className='row playerHistoryVideosRow'>
								<div className='col-lg-3 col-sm-3'></div>

								<div className='col-lg-6 col-sm-6 playerHistoryVideosColumn'>
									{listOfVideos.map((video, key) => {
										return (
											<div
												key={video._id || `player-video-${key}`}
												className='playerHistoryVideo'
											>
												<h1 className='playerHistoryVideo__title'>
													{video.videoTitle}
												</h1>

												<p className='caption playerHistoryVideo__caption'>
													{video.videoCaption}
												</p>

												<div className='playerHistoryVideo__embed'>
													<YouTube videoId={ids[key]} />
												</div>
											</div>
										)
									})}
								</div>

								<div className='col-lg-3 col-sm-3'></div>
							</div>
						</div>
					</div>
				)}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default PlayerHistory
